import { MutationTree } from 'vuex';
import { Request } from '@/interface/store/request';
import { initialState } from '@/store/modules/request/index';

export const mutations: MutationTree<Request> = {
  SET_REQUESTS(state, payload) {
    state.dataList = payload.data;
    state.statusCount = payload.statusCount;
    state.totalCount = payload.totalCount;
  },
  SET_MOBILE_REQUESTS(state, payload) {
    state.dataList = state.dataList.concat(payload.data);
    state.statusCount = payload.statusCount;
    state.totalCount = payload.totalCount;
  },
  SET_REQUEST(state, payload) {
    state.requestData = payload;
  },
  SET_QUERY_PARAMS(state, payload) {
    state.queryParams = payload;
  },
  UPDATE_QUERY_PARAMS(state, payload) {
    state.queryParams = Object.assign(state.queryParams, payload);
  },
  SET_REQUEST_ATTACHMENTS(state, payload) {
    state.requestAttachments = payload.data;
  },
  SET_REQUEST_COMMENTS(state, payload) {
    state.requestComments = payload.data;
  },
  SET_REQUEST_HISTORIES(state, payload) {
    state.requestHistories = payload.data;
  },
  SET_PO(state, payload) {
    state.poList = payload.data;
    state.poListTotalCount = payload.totalCount;
  },
  SET_REQUEST_FILTER(state, payload) {
    state.requestFilter = payload;
  },
  SET_REQUEST_FILTER_STACK(state, payload) {
    state.requestFilterStack = payload;
  },
  IS_DRAWER_OPEN(state, bool: boolean) {
    state.isDrawerOpen = bool;
  },
  IS_TOOLTIP_SHOWN(state, bool: boolean) {
    state.isTooltipShown = bool;
  },
  RESET_ALL(state) {
    const initialInventoryState = initialState();
    Object.keys(initialInventoryState).forEach((key: any) => {
      (state as any)[key] = (initialInventoryState as any)[key];
    });
  },
};
